import videoGalleryApi from "../api/video-gallery-api";

const generateLinkVideoGalleryById = async (payload) => {
    const resp = await videoGalleryApi.generateLinkVideoGalleryById(payload);
    // console.log('embed' ,resp);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const moveFile = async (payload) => {
    const resp = await videoGalleryApi.moveFile(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const createFolder = async (payload) => {
    const resp = await videoGalleryApi.createFolder(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    const resp = await videoGalleryApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (payload) => {
    const resp = await videoGalleryApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await videoGalleryApi.search(condition, pagination);
        // console.log(result);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const add = async (photoGallery) => {
    const resp = await videoGalleryApi.add(photoGallery);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const videoGalleryService = {
    generateLinkVideoGalleryById,
    moveFile,
    createFolder,
    edit,
    search,
    remove,
    add
};

export default videoGalleryService;
